import React from "react";

import "../../../../../Utils/Css/Menu.css";

export default function Menu() {
  return (
    <div className="menuContainer primary white">
      <div className="large menuExchange">SUPER</div>
      <div className="large menuExchange">BOOKED</div>
      <div className="large menuExchange">LIVE P&L</div>
      <div className="large menuExchange">NET P&L</div>

      <div className="large menuExchange">SELF LIVE P&L</div>
    </div>
  );
}
